export const walletMessages = {
  // Transaction messages
  TX_GENERIC_REJECTED: 'Transaction was rejected.',
  TX_GENERIC_COMPLETED: 'Transaction completed.',
  TX_GENERIC_ERROR: 'Something went wrong! Try reloading the page.',
  TX_GENERIC_ERROR_MESSAGE: 'Something went wrong!',
  TX_GENERIC_ERROR_RELOAD: 'Try reloading the page.',
  TX_PENDING: 'Transaction detected, waiting for confirmation',
  TX_CONFIRMED: 'Transaction confirmed',
  TX_SWITCH_NETWORK: 'Try switching to the network manually in your wallet settings.',
  TX_WALLET_RPC_ERROR_MESSAGE: 'Wallet RPC is not responding.',
  TX_WALLET_RPC_ERROR_UPDATE: 'Try updating the RPC URL in your wallet settings.',
};
